export const DETAIL_PANEL_WIDTH = 728;
export const SUCCESS_MESSAGE_TIMEOUT = 3000;
